import { apiClient } from "./client";
import type {
    RetailPromotionArticlesResponse,
    RetailPromotionsResponse,
} from "./retailPromotions";

export type ExpoPromotionsResponse = RetailPromotionsResponse;
export type ExpoPromotionArticlesResponse = RetailPromotionArticlesResponse;

export async function fetchExpoPromotionsReport(params: {
    period?: string;
    dateFrom?: string;
    dateTo?: string;
    baseDateFrom?: string;
    baseDateTo?: string;
}) {
    const { data } = await apiClient.get<ExpoPromotionsResponse>("/b2b/promotions", {
        params: {
            period: params.period,
            date_from: params.dateFrom,
            date_to: params.dateTo,
            base_date_from: params.baseDateFrom || undefined,
            base_date_to: params.baseDateTo || undefined,
        },
    });

    return data;
}

export async function fetchExpoPromotionArticles(
    ruleId: number,
    params: {
        period?: string;
        dateFrom?: string;
        dateTo?: string;
        search?: string;
        page?: number;
        perPage?: number;
        soldOnly?: boolean;
    },
) {
    const { data } = await apiClient.get<ExpoPromotionArticlesResponse>(
        `/b2b/promotions/${ruleId}/articles`,
        {
            params: {
                period: params.period,
                date_from: params.dateFrom,
                date_to: params.dateTo,
                search: params.search,
                page: params.page,
                per_page: params.perPage,
                sold_only: params.soldOnly ? 1 : undefined,
            },
        },
    );

    return data;
}

export async function updateExpoPromotionMarketingCost(ruleId: number, marketingCost: number) {
    const { data } = await apiClient.put<{ ruleId: number; marketingCost: number }>(
        `/b2b/promotions/${ruleId}/marketing-cost`,
        { marketing_cost: marketingCost },
    );

    return data;
}
